import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Brand from './Brand';

const { FiArrowRight, FiEye, FiMail, FiLock, FiUser } = FiIcons;

export default function Auth({ mode, navigate }) {
  const [submitted, setSubmitted] = useState(false);
  const title = mode === 'signup' ? 'إنشاء حساب' : mode === 'forgot' ? 'استعادة كلمة المرور' : 'تسجيل الدخول';

  const submit = (event) => {
    event.preventDefault();
    if (mode === 'signup') navigate('/onboarding');
    else if (mode === 'login') navigate('/dashboard');
    else setSubmitted(true);
  };

  return (
    <main className="auth-page">
      <button className="back-link" onClick={() => navigate('/')}><SafeIcon icon={FiArrowRight} /> العودة للرئيسية</button>
      <section className="auth-card">
        <Brand />
        <div className="auth-heading">
          <h1>{title}</h1>
          <p>{mode === 'signup' ? 'ابدأ باكتشاف فرص تحسين إيرادات عيادتك.' : mode === 'forgot' ? 'سنرسل لك رابطًا آمنًا لإعادة تعيين كلمة المرور.' : 'مرحبًا بعودتك إلى Cencey.'}</p>
        </div>
        {submitted ? (
          <div className="success-box">تم إرسال رابط الاستعادة إلى بريدك الإلكتروني.</div>
        ) : (
          <form onSubmit={submit}>
            {mode === 'signup' && <Field icon={FiUser} label="الاسم الكامل" type="text" placeholder="مثال: خالد العتيبي" />}
            <Field icon={FiMail} label="البريد الإلكتروني للعمل" type="email" placeholder="name@clinic.com" />
            {mode !== 'forgot' && <Field icon={FiLock} label="كلمة المرور" type="password" placeholder="8 أحرف على الأقل" extra={FiEye} />}
            {mode === 'login' && <button type="button" className="text-button" onClick={() => navigate('/forgot')}>نسيت كلمة المرور؟</button>}
            <button className="btn primary full" type="submit">{mode === 'signup' ? 'إنشاء الحساب' : mode === 'forgot' ? 'إرسال رابط الاستعادة' : 'تسجيل الدخول'}</button>
          </form>
        )}
        <p className="auth-switch">
          {mode === 'signup' ? 'لديك حساب بالفعل؟' : 'ليس لديك حساب؟'}
          <button onClick={() => navigate(mode === 'signup' ? '/login' : '/signup')}>{mode === 'signup' ? 'تسجيل الدخول' : 'إنشاء حساب'}</button>
        </p>
      </section>
    </main>
  );
}

function Field({ icon, label, extra, ...props }) {
  return (
    <label className="field">
      <span>{label}</span>
      <div><SafeIcon icon={icon} /><input required {...props} />{extra && <SafeIcon icon={extra} />}</div>
    </label>
  );
}